import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { Rsvp } from './pages/Rsvp';
import { Itinerary } from './pages/Itinerary';

import { Login } from './pages/Login';
import { ProtectedRoute } from './components/security/ProtectedRoute';
import { AdminProtectedRoute } from './components/security/AdminProtectedRoute';
import { Admin } from './pages/Admin';

export const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/',
        element: <ProtectedRoute />,
        children: [
            {
                path: '',
                element: <App />,
                children: [
                    {
                        index: true,
                        element: <Home />,
                    },

                    {
                        path: 'events',
                        element: <Events />,
                    },
                    {
                        path: 'rsvp',
                        element: <Rsvp />,
                    },
                    {
                        path: 'itinerary',
                        element: <Itinerary />,
                    },
                    // Protected Admin Routes
                    {
                        element: <AdminProtectedRoute />,
                        children: [
                            {
                                path: 'admin/*',
                                element: <Admin />,
                            }
                        ]
                    },
                ],
            },
        ],
    },
]);
